import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowExpandOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowExpandOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m12.75 3.255-2.01 2h6.59L5.25 17.335v-6.6l-2 1.99v8.02h8.02l2-2h-6.6l12.08-12.08v6.59l2-2v-8h-8Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowExpandOutlined;